import { camelizeObject } from '@cvt/helpers/object';

export const mapUniversityData = (data: Universities.UniversityApi): Universities.University => {
  const university = camelizeObject<Universities.University>(data);
  return {
    ...university,
    internationalStudentRatio: data.international_student_ratio ? (data.international_student_ratio) / 100 : null,
    match: {
      ...university.match,
      value: (university.match?.value || 0) / 100,
    },
  };
};
